import {
  FolderIcon,
  UsersIcon,
  ArrowRightOnRectangleIcon,
  ChartBarIcon,
  BookOpenIcon,
} from '@heroicons/react/24/outline'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import GlobalMessageNotification from '../messaging/notifications/GlobalMessageNotification'

const navigation = [
  { name: 'Projects', href: '/projects', icon: FolderIcon },
  { name: 'Statistics', href: '/statistics', icon: ChartBarIcon },
]

export default function Navigation() {
  const location = useLocation()
  const { user, logout, exitImpersonation } = useAuth()

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-primary-600">
              ArtemisAI Label Platform
            </Link>

            <div className="flex space-x-4">
              {navigation.map(item => {
                const isActive = location.pathname === item.href
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <item.icon className="w-4 h-4 mr-2" />
                    {item.name}
                  </Link>
                )
              })}
              {user?.is_admin && (
                <Link
                  to="/users"
                  className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    location.pathname === '/users'
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`}
                >
                  <UsersIcon className="w-4 h-4 mr-2" />
                  Users
                </Link>
              )}
              <Link
                to="/annotation-guide"
                className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === '/annotation-guide'
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <BookOpenIcon className="w-4 h-4 mr-2" />
                Annotation Guide
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {/* Global Message Notification */}
            <GlobalMessageNotification />

            <div
              className={`text-sm ${user?.is_impersonating ? 'text-purple-600 font-semibold' : 'text-gray-600'}`}
            >
              {user?.is_impersonating ? (
                <>
                  <span className="text-gray-500">Impersonating:</span> {user?.name}
                </>
              ) : (
                user?.name
              )}
            </div>
            {user?.is_impersonating ? (
              <button
                onClick={exitImpersonation}
                className="flex items-center text-purple-600 hover:text-purple-800 text-sm font-medium"
              >
                <ArrowRightOnRectangleIcon className="w-4 h-4 mr-1" />
                Exit Impersonation
              </button>
            ) : (
              <button
                onClick={logout}
                className="flex items-center text-gray-600 hover:text-gray-900 text-sm font-medium"
              >
                <ArrowRightOnRectangleIcon className="w-4 h-4 mr-1" />
                Logout
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}
